import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const SelectedPressItem = ({
    items,
    isInModal,
}) => {

    return (
        <div className={'layout-container-padding-right z-10 relative flex flex-wrap max-w-container bg-white editorial-white-border-b editorial-white-spacing-t'}>
            {/* Left Sidebar */}
            <div className='w-sidebar'>
                <div className='flex flex-col items-center'>
                    <h2 className='type-style-8 inline-block align-middle rotate-180 writing-mode-vertical-rl'>
                        Selected Press
                    </h2>
                </div>
            </div>
            {/* Body */}
            <div className='flex-1 layout-negative-margin'>
                <section className={`${isInModal? '' : 'w-text-module'} layout-item-padding`}>
                    {items?.length > 0 &&
                        <ul className='w-full'>
                            {items.map((item, i, {length}) => {
                                const isLast = length - 1 === i;

                                return (
                                    <li
                                        className={`${!isLast ? 'mb-40' : ''}`}
                                        key={`external-link-${i}`}>
                                        <a
                                            href={item.relativeUrl}
                                            rel='noreferrer noopener'
                                            target='_blank'>
                                            <h4 className='type-style-4'>
                                                {item.title}
                                            </h4>
                                            <p className='type-style-8 mt-20'>
                                                {item?.credit && (
                                                    <span className='mr-10'>
                                                        {item.credit}
                                                    </span>
                                                )}
                                                <span className='type-style-7'>
                                                    {dayjs(item.publicationDate).format('DD/MM/YYYY')}
                                                </span>
                                            </p>
                                        </a>
                                    </li>
                                );
                            })}
                        </ul>
                    }
                </section>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
        credit: PropTypes.string.isRequired,
        publicationDate: PropTypes.string,
        relativeUrl: PropTypes.object,
        title: PropTypes.string.isRequired,
    })),
    isInModal: PropTypes.bool,
};


SelectedPressItem.propTypes = propTypes;

export default SelectedPressItem;
